import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

@Component({
	selector: "custom-form-multi-picture",
	styleUrls: ["./multi-picture.component.scss"],
	template: `
		@if (render) {
			<div class="dynamic-field form-multi-picture" [formGroup]="group">
				<ng-content select="h3" />

				<ic-multi-picture [formControlName]="config.name" [namespace]="config.namespace" />
			</div>
		}
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FormMultiPictureComponent {
	@Input() config: any;
	// @ts-expect-error TS2564
	@Input() group: UntypedFormGroup;

	get render() {
		const control = this.group.get(this.config.name);

		// @ts-expect-error TS18047
		return control.enabled;
	}
}
